import React, { useState, useEffect } from 'react';
import Sportsnewsallnews from '../../Components/SportsNews/Sportsnewsallnews';
import Sportsnewsherobanner from '../../Components/SportsNews/Sportsnewsherobanner';
import NewsSkeletonBanner from '../../Components/Skeleton/NewsSkeletonBanner';
import ViewAllSkeleton from '../../Components/Skeleton/ViewAllSkeleton';
import { Helmet } from 'react-helmet';

function SportsnewsViewAll() {
  const [loading, setLoading] = useState(true);
  const [allSportsNews, setAllSportsNews] = useState([]);
  

  useEffect(() => {
    
    const fetchData = async () => {
      const apiUrl = process.env.REACT_APP_API_URL_NEWS;
      console.log(`API URL: ${apiUrl}`);
      

      try {
        const response = await fetch(apiUrl);
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        const data = await response.json();
        console.log('Fetched data:', data);
        
        // const allNews = [...data.sportsVideo, ...data.sportsPhoto];
        // console.log('Combined sports news:', allNews);

        const publishedNews = data.filter(news => news.status === 'published');
        console.log('Filtered published news:', publishedNews);
        
        setAllSportsNews(publishedNews);
      } catch (error) {
        console.error("Error fetching data:", error);
      }

    
      await new Promise((resolve) => setTimeout(resolve, 1000));
      setLoading(false);
    };

    fetchData();
  }, []);



    if (allSportsNews.length === 0) {
    return <div><NewsSkeletonBanner />
          <ViewAllSkeleton /></div>; 
  }
  console.log('All sports news:', allSportsNews); 
  return (
    <>
    <Helmet>
        <title>All Sports News - Stay Updated with the Latest Sports Stories</title>
        <meta name="description" content="Browse through our collection of published sports news articles. Stay updated with the latest in sports, including articles, videos, and photos." />
        <meta name="keywords" content="sports news, latest sports articles, sports updates, published news" />
        <meta property="og:title" content="All Sports News - Stay Updated with the Latest Sports Stories" />
        <meta property="og:description" content="Browse through our collection of published sports news articles. Stay updated with the latest in sports." />
        <meta property="og:type" content="website" />
        <meta property="og:url" content={window.location.href} />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="All Sports News - Stay Updated with the Latest Sports Stories" />
        <meta name="twitter:description" content="Browse through our collection of published sports news articles. Stay updated with the latest in sports." />
      </Helmet>
      {loading ? (
        <>
          <NewsSkeletonBanner />
          <ViewAllSkeleton />
        </>
      ) : (
        <>
          <Sportsnewsherobanner data={allSportsNews} />
          <Sportsnewsallnews allSportsNews={allSportsNews} />
        </>
      )}
    </>
  );
}

export default SportsnewsViewAll;
